import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import _e from 'common/localeUtil';
import GenericDialog from './GenericDialog';
import { getEntityWebsiteReportEbook } from '../../utils';

const useStyles = makeStyles(() => ({
	dialogContent: {
		paddingBottom: 30
	},
	launchText: {
		color: '#225bab'
	}
}));

const SaveSuccessfulDialog = ({ open, handleClose }) => {
	const classes = useStyles();
	const entity = getEntityWebsiteReportEbook();

	let message;
	if (window.GM_BRANDING_TYPE_REPORT_EBOOK) {
		if (window.currentStatus === 'P') {
			message = (
				<>
					{`${_e('entity_saved', {
						entity
					})} ${_e('click')}`}{' '}
					<span className={classes.launchText}>{_e('publish')}</span>{' '}
					{`${_e('to_publish_latest_changes')}`}
				</>
			);
		} else {
			message = (
				<>
					{`${_e('entity_saved_not_launched', {
						entity
					})} ${_e('click')}`}{' '}
					<span className={classes.launchText}>{_e('launch')}</span>{' '}
					{`${_e('to_make_it_visible')}`}
				</>
			);
		}
	} else if (window.currentStatus === 'P') {
		message = (
			<>
				{`${_e('entity_saved', {
					entity
				})} ${_e('click')}`}{' '}
				<span className={classes.launchText}>{_e('publish')}</span>{' '}
				{`${_e('to_publish_latest_changes')}`}
			</>
		);
	} else {
		message = (
			<>
				{`${_e('entity_saved_not_launched', {
					entity
				})} ${_e('click')}`}{' '}
				<span className={classes.launchText}>{_e('launch')}</span>{' '}
				{`${_e('to_make_it_visible')}`}
			</>
		);
	}

	return (
		<GenericDialog
			content={
				<div>
					<Typography variant="body1">{message}</Typography>
				</div>
			}
			handleClose={handleClose}
			confirmAction={handleClose}
			open={open}
			title={_e('save_successful')}
		/>
	);
};

SaveSuccessfulDialog.propTypes = {
	open: PropTypes.bool,
	handleClose: PropTypes.func
};

export default SaveSuccessfulDialog;
